export default __webpack_public_path__ + "static/media/fishing_boats_zaante_town_marine_zakinthos_greece.a7bd8862.webp";